import React from 'react';
import { Monitor } from 'lucide-react';

// Check if device is mobile
export const isMobile = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < 768 || /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};

// Hook to track mobile state with resize
export const useIsMobile = () => {
  const [mobile, setMobile] = React.useState(isMobile());
  
  React.useEffect(() => {
    const handleResize = () => setMobile(isMobile());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return mobile;
};

// Component to show desktop-only message
export const DesktopOnlyFeature = ({ feature = "This feature", children }) => {
  const mobile = useIsMobile();
  
  if (!mobile) return children;
  
  return (
    <div className="flex flex-col items-center justify-center min-h-[300px] p-6 text-center">
      <div className="w-16 h-16 bg-zinc-100 rounded-2xl flex items-center justify-center mb-4">
        <Monitor className="w-8 h-8 text-zinc-400" />
      </div>
      <h3 className="text-lg font-semibold text-zinc-800 mb-2">Desktop Required</h3>
      <p className="text-sm text-zinc-500 max-w-xs">
        {feature} is optimized for desktop. Please access this from a computer for the best experience.
      </p>
    </div>
  );
};

// Wrapper that hides content on mobile
export const HideOnMobile = ({ children }) => {
  const mobile = useIsMobile();
  if (mobile) return null;
  return children;
};

// Wrapper that shows content only on mobile
export const ShowOnMobile = ({ children }) => {
  const mobile = useIsMobile();
  if (!mobile) return null;
  return children;
};
